module.exports = __webpack_public_path__ + "img/90.bf0fed92.jpg";